import { linkEditing } from '@yola/ws-sdk';

const { linkTypes: allLinkTypes } = linkEditing.constants;

const linkTypes = {
  ANCHOR: allLinkTypes.ANCHOR,
  EXTERNAL: allLinkTypes.EXTERNAL,
  PHONE: allLinkTypes.PHONE,
  MAIL: allLinkTypes.MAIL,
  PAGE: allLinkTypes.PAGE,
  DOWNLOAD: allLinkTypes.DOWNLOAD,
};

export default linkTypes;
export { allLinkTypes };
